import React from 'react';
import { withStyles } from '@material-ui/core/styles';

/*
Displaying user's email
*/


const styles = theme => ({
  
});
class UserInfo extends React.Component {
  render(){
    return(
      <p>{this.props.email}</p>
    )
  }
}


export default withStyles(styles, { withTheme: true })(UserInfo);



// WEBPACK FOOTER //
// ./src/components/general/UserInfo.js